import useInputId from "@ui/hooks/unique-id";
import React, { ReactNode } from "react";

export interface CheckboxProps extends React.ComponentProps<"input"> {
  name: string;
  value?: string;
  label?: ReactNode;
  error?: string;
  checked?: boolean;
  description?: ReactNode;
  className?: string;
}

export function Checkbox(props: CheckboxProps) {
  const id = useInputId(props);

  return (
    <div className="flex items-start">
      <div className="flex items-center h-5">
        <input
          type="checkbox"
          id={id}
          aria-describedby={`${id}-description`}
          checked={props.checked}
          name={props.name}
          onChange={props?.onChange}
          className="w-5 h-5 text-purple-600 border-border rounded focus:ring-purple-500 checked:bg-purple-600"
        />
      </div>
      <div className="ml-3 text-sm">
        <label htmlFor={id} className="font-medium text-foreground">
          {props.label}
        </label>
        {props.description && (
          <p id={`${id}-description`} className="text-muted-foreground">
            {props.description}
          </p>
        )}
      </div>
    </div>
  );
}

export function CheckboxGroup({
  label,
  description,
  children,
}: {
  label: ReactNode;
  description?: string;
  children: ReactNode;
}) {
  return (
    <fieldset>
      <div className="mb-3">
        <legend className="block font-medium text-foreground">{label}</legend>
      </div>
      {description && <p className="text-sm text-muted-foreground">{description}</p>}
      <div className="space-y-5">{children}</div>
    </fieldset>
  );
}
